import { useAuth, useUser } from '@clerk/clerk-react'

export function useIsAdmin() {
  const { sessionClaims } = useAuth()
  const { user } = useUser()

  // Check both sessionClaims (JWT) and user.publicMetadata (fresh from API)
  // This handles cases where JWT is stale but user object has updated metadata
  return (
    sessionClaims?.app_role === 'admin' ||
    user?.publicMetadata?.app_role === 'admin'
  )
}